import React from 'react';

interface Props {
  className?: string;
}

/**
 * SSOログイン時にIdPとAI Travelのユーザーが一致しない場合のエラーメッセージ
 * error_type=NotSameUser でリダイレクトされた際に表示
 */
const SSONotSameUserError: React.FC<Props> = ({ className }) => {
  return (
    <div className={className}>
      <p style={{ marginBottom: '8px' }}>SSOログインに失敗しました。</p>
      <p style={{ marginBottom: '8px' }}>以下をご確認ください:</p>
      <ul style={{ marginLeft: '20px', marginBottom: '8px', listStyleType: 'disc' }}>
        <li>連携先のサービスに正しいアカウントでログインしているか</li>
        <li>ログインしようとしているアカウントと連携先のアカウントが一致しているか</li>
      </ul>
      <p>問題が解決しない場合は、一度連携先のサービスからログアウトして、再度お試しください。</p>
    </div>
  );
};

export default SSONotSameUserError;
